export default __webpack_public_path__ + "static/media/03_photo.a57f5713.jpg";